import { getUid } from "../auth";
import { doc, getFirestore, collection } from "firebase/firestore";

export function getDocRef(collection) {
  let finalCollection = String(collection);

  if (collection.includes("{{uid}}")) {
    const { uid } = getUid();

    finalCollection = finalCollection.replace("{{uid}}", `${uid}`);
  }

  const db = getFirestore();
  return doc(db, `${finalCollection}`);
}

export function getCollectionRef(col) {
  let finalCol = String(col);
  const { uid } = getUid();

  finalCol = finalCol.replace("{{uid}}", `${uid}`);

  const db = getFirestore();
  return collection(db, `${finalCol}`);
}
